import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface RegisterDeviceParams {
  token: string
}

const registerDevice = async ({ token }: RegisterDeviceParams): Promise<void> => {
  await api.post('/devices', { token })
}

/**
 * Register an FCM device token with the API. The backend dedupes by
 * token (existing token returns 409 — we swallow it as a no-op so the
 * token-refresh path can re-register safely).
 */
export const useRegisterDevice = () => {
  return useMutation<void, Error, RegisterDeviceParams>({
    mutationFn: registerDevice,
    onError: (err: Error & { response?: { data?: { code?: string } } }) => {
      const code = err.response?.data?.code
      if (code === 'Notifications.DeviceAlreadyRegistered') {
        // Idempotent: token is already in the table for this account.
        return
      }
      throw err
    },
  })
}
